<script>
import {checkboxInputMixin} from "../../../helpers/checkboxInput.js"

export default {
    mixins: [checkboxInputMixin],
    props: {
        platformFields: Object
    },
    data() {
        return {
            fields: {}
        }
    },
    created() {
        this.platformFields.data.map(field => {
            this.$set(this.fields, field.id, {
                checked: false
            })
        });
    },
    computed: {
        hasChecked() {
            for (let key in this.fields) {
                if (this.fields[key].checked) {
                    return true;
                }
            }
            return false;
        },
        selectedFields() {
            return Object.keys(this.fields).filter(index => {
                return this.fields[index].checked;
            });
        }
    }
}
</script>
